import jss from 'jss'
import jssGlobal from 'jss-global'
import jssDefaultUnit from 'jss-default-unit'
import jssNested from 'jss-nested'
import jssVendorPrefixer from 'jss-vendor-prefixer'
import jssCamelCase from 'jss-camel-case'

jss.use(jssGlobal())
jss.use(jssDefaultUnit())
jss.use(jssNested())
jss.use(jssVendorPrefixer())
jss.use(jssCamelCase())

export const generateStylesheet = function (styles = {}, options = {}) {
  const sheet = jss.createStyleSheet(styles, options)
  const css = sheet.toString() || ''
  const classes = sheet.classes || {}

  return { sheet, css, classes }
}

export const generatePrintStylesheet = function (styles = {}, options = {}) {
  return generateStylesheet(styles, {
    ...options,
    media: 'print',
    classNamePrefix: 'print-'
  })
}



// WEBPACK FOOTER //
// ./src/util/stylesheets.js